import { ObservableQuery } from '@apollo/client';
import { OrganisationMember } from '@ih/app/shared/apis/interfaces';

export class FindAllOrganisationMembersSuccess {
  public static readonly type =
    '[Organisation/OrganisationMembers/List] FindAllOrganisationMembersSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllOrganisationMembers: OrganisationMember[];
    }>,
  ) {}
}
